import { createGlobalStyle, css } from 'styled-components'

const headingStyles = css`
  ${['h1','h2','h3','h4','h5','h6','p','small'].map(tag => `
    ${tag} {
      font-size: ${props => props.theme.typography[tag]?.fontSize || '1rem'};
      font-weight: ${props => props.theme.typography[tag]?.fontWeight || '400'};
      line-height: ${props => props.theme.typography[tag]?.lineHeight || '1.5'};
      color: ${props => props.theme.typography[tag]?.color || props.theme.colors.textPrimary};
      margin: 0;
    }
  `).join('')}
`

const GlobalStyles = createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  html, body {
    margin: 0;
    padding: 0;
    min-height: 100%;
  }

  body {
    font-family: ${({ theme }) => theme.typography.fontFamily};
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.textPrimary};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  ul, ol {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  button {
    font-family: inherit;
  }

  /* Optional: scrollbar styling */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colors.textMuted};
    border-radius: 4px;
  }

  /* Apply heading and paragraph styles dynamically */
  ${headingStyles}
`

export default GlobalStyles
